import cms from 'dw-uk-cms';

class BottleScannerPromise {

	/**
	 * Constructor Class to call the default functions
	 */
	constructor() {
		this.getBottleScannerDataFeed();
	}

	/**
	 * Get the Bottle Scanner Data feed from API
	 */
	getBottleScannerDataFeed() {
		return new Promise((resolve, reject) => {
			cms.get('bottleScannerDataFeed').then(bottleScannerData => {
				this.bottleScannerData = bottleScannerData;
				resolve(bottleScannerData);
			}).catch(error => {
				reject(error);
			});
		});
	}

	/**
	 * Retrieve the bottleScanner Data
	 */
	retrieveScannerData() {
		return this.bottleScannerData;
	}

}

export default new BottleScannerPromise();
